<template>
	<component :is="component" :data="data" :monthlySavings="savings - getSmartPackagePrice" />
</template>

<script>
import RoiCalc from './components/RoiCalc'
import RoiResults from './components/RoiResults'

export default {
	name: 'ROICALC',
	components: {
		RoiCalc,
		RoiResults
	},
	props: {
		getSmartPackagePrice: {
			type: [Number],
			default: 499
		},
		ctaUrl: {
			type: [String],
			default: 'https://dataself.com'
		}
	},
	data () {
		return {
			component: 'RoiCalc',
			savings: 499,
			data: {}
		}
	},
	created() {
		this.formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2
		});
	},
	methods: {
		goToPage() {
			window.location.href = this.ctaUrl 
				+ '?labor-hours=' + this.data.analyst
				+ '&reports-hours=' + this.data.reports
				+ '&analyst-wage=' + this.data.labor
		}
	}
}
</script>
<style>
.application--wrap {
	min-height: 0;
}
.application.theme--light .row {
	margin-left: 0 !important;
	margin-right: 0 !important;
}
.application.theme--light hr {
	background-color: transparent !important;
	margin: 0 !important;
}
</style>